<template>
  <md-table
    v-model="contacts"
    class="table-striped"
    table-header-color="primary"
  >
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
      <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
      <md-table-cell class="text-right">
        <md-button
          v-if="canDelete()"
          class="md-just-icon md-danger"
          @click="deleteItem(item.id)"
        >
          <md-icon>delete</md-icon>
        </md-button>
        &nbsp;
        <edit-button
          :isSmall="true"
          @edit-click="editContractorContact(item.id)"
        ></edit-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state
      md-label="No Contractor Contacts Found"
    ></md-table-empty-state>
  </md-table>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "ContractorContactsList",
  computed: {
    ...mapGetters({
      contacts: "data-management-contractor/contacts"
    })
  },
  methods: {
    editContractorContact(id) {
      this.$router.push({
        name: "Edit Contractor Contact",
        params: { contactId: id }
      });
    },
    canDelete() {
      return this.$auth.isInGlobalRole();
    },
    deleteItem(id) {
      Swal.fire({
        text: `Are you sure you want to delete this item?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-contractor/deleteContact", id)
            .then(() => {})
            .catch(error => {
              this.$notify({
                message: error.response.data,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    }
  }
};
</script>

<style></style>
